import React, { useEffect, useRef, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";

import {
    Tag,
    Button,
    Col,
    Divider,
    Dropdown,
    Icon,
    Input,
    Menu,
    message,
    Modal,
    Row,
    Table,
    Typography,
    Upload,
    Switch,
    Select,
} from "antd";
import { ReactComponent as UserLogo } from "./Svg/user-management.svg";
import { ReactComponent as BusinessmanLogo } from "./Svg/Businessman.svg";
import { ReactComponent as AdminPremissionUserLogo } from "./Svg/AdminPremissionUser.svg";
import { ReactComponent as AdminPremissionUsernameLogo } from "./Svg/AdminPremissionUsername.svg";
import { ReactComponent as AdminPremissionEmailLogo } from "./Svg/AdminPremissionEmail.svg";
import { ReactComponent as AdminPremissionRoleLogo } from "./Svg/AdminPremissionRole.svg";

import Loader from "components/Loader/Loader";
// .ant-upload.ant-upload-select-picture-card {
//   display: none;
// }
import "./Users.scss";
import {
    createInaamAdmin,
    setAdminPermissions,
    deleteInaamAdmin,
    fetchInaamAdminList,
    updateInaamAdminStatus,
    getAdminPermissions,
    updateInaamAdmin,
} from "utils/apiService";
import { countries } from "constants/CountryList";
import { handelChange } from "actions/channelProduct";
import ActivityManagment from "./ActivityManagment";
import user from "reducers/user";

const { Text } = Typography;
const { Dragger } = Upload;
const { Option } = Select;

const Roles = ["admin", "super_admin"];

const Usertype = localStorage.getItem("user_type");

const permissionList = [
    {
        name: "Reports",
        key: "REPORTS",
    },
    {
        name: "Store Control Center",
        key: "STORE_CONTROL_CENTER",
    },
    {
        name: "Customer Support",
        key: "CUSTOMER_SUPPORT",
    },
    {
        name: "User Administration",
        key: "USER_ADMINISTRATION",
    },
];
const permissionListadmin = [
    // {
    //     name: "Analytics",
    //     key: "ANALYTICS",
    // },
    {
        name: "Reports",
        key: "REPORTS",
    },
    {
        name: "Store Control Center",
        key: "STORE_CONTROL_CENTER",
    },
    {
        name: "Customer Support",
        key: "CUSTOMER_SUPPORT",
    },
];

const UserTable = (props) => {
    const { data, loadTable } = props;

    const [userdata, setUserdata] = useState(null);
    const [permissionData, setPermissionData] = useState([]);

    const [addModal, setaddModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [permissionModal, setPermissionModal] = useState(false);

    const columns = [
        {
            title: "Member Name",
            dataIndex: ["name", "email", "first_name", "last_name"],
            key: "memberName",
            render: (_, data) => {
                return (
                    <div
                        style={{
                            width: "250px",
                            display: "flex",
                            marginRight: "0px",
                        }}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}>
                            <Text
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    lineHeight: "24px",
                                    color: "#181818",
                                    // whiteSpace: "nowrap",
                                    //   overflow: "scroll",
                                }}>
                                {data.first_name ? `${data.first_name} ${data?.last_name}` : "-"}
                            </Text>
                            <Text>{data.email ? data.email : "-"}</Text>
                        </div>
                    </div>
                );
            },
        },
        {
            title: "Username",
            dataIndex: "username",
            key: "username",
            render: (data) => {
                return (
                    <Text
                        style={{
                            width: "150px",
                            whiteSpace: "nowrap",

                            fontStyle: "normal",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "24px",

                            display: "flex",
                            alignItems: "flex-end",

                            color: "#464646",
                        }}>
                        {data ? data : "-"}
                    </Text>
                );
            },
        },
        {
            title: "Role",
            dataIndex: "admin_type",
            key: "role",
            render: (data) => {
                return (
                    <div>
                        <Tag
                            className={data ? data : "ADMIN"}
                            style={{
                                whiteSpace: "nowrap",
                                textTransform: "capitalize",
                                padding: "0px 4px",
                            }}>
                            {data ? data.toString().replace("_", " ") : "ADMIN"}
                        </Tag>
                    </div>
                );
            },
        },
        // {
        //     title: "Created on",
        //     dataIndex: "date_created",
        //     key: "created-on",
        //     render: (data) => {
        //         return (
        //             <div style={{ width: "150px" }}>
        //                 <Text
        //                     style={{
        //                         whiteSpace: "nowrap",
        //                     }}>
        //                     {data ? data : "-"}
        //                 </Text>
        //             </div>
        //         );
        //     },
        // },
        {
            title: "Status",
            dataIndex: ["status", "username"],
            key: "status",
            render: (_, data) => {
                return (
                    <div style={{ width: "120px" }}>
                        <Switch
                            defaultChecked={data.status}
                            onChange={() => {
                                // setStatus(!Status);
                                updateInaamAdminStatus({
                                    requestData: {
                                        username: data.username,
                                        status: !data.status,
                                    },
                                    res200Callback: (res) => {
                                        loadTable();
                                        message.success("Status updated successfully");
                                    },
                                });
                            }}
                        />
                        <Text
                            style={{
                                marginLeft: "14px",
                                fontStyle: "normal",
                                fontWeight: `${data.status ? "700" : "normal"}`,
                                fontSize: "14px",
                                lineHeight: "22px",
                                color: `${data.status ? "#fec708" : ""}`,
                            }}>
                            {data.status ? "Active" : "Inactive"}
                        </Text>
                    </div>
                );
            },
        },
        {
            title: "",
            dataIndex: ["username", "email", "first_name", "last_name"],
            key: "uuid",
            render: (_, data) => {
                // console.log(row);
                return (
                    <div style={{ width: "16px" }}>
                        <Dropdown
                            placement={"bottomLeft"}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            width={30}
                            style={{ marginLeft: "0", width: "30px", height: "40px" }}
                            overlay={
                                <Menu>
                                    <Menu.Item
                                        onClick={(e) => {
                                            e.domEvent.stopPropagation();
                                            setUserdata(data);
                                            getAdminPermissions({
                                                requestData: {
                                                    username: data?.username,
                                                },
                                                res200Callback: (res) => {
                                                    setPermissionModal(true);
                                                    setPermissionData(res.data.permission_list);
                                                },
                                            });
                                        }}>
                                        <Text style={{ color: "#181818" }}>Edit Premissons</Text>
                                    </Menu.Item>

                                    <Menu.Item
                                        onClick={(e) => {
                                            e.domEvent.stopPropagation();
                                            setUserdata(data);
                                            setDeleteModal(true);
                                        }}>
                                        <Text style={{ color: "#C91713" }}>Delete</Text>
                                    </Menu.Item>
                                </Menu>
                            }>
                            <Icon
                                type='more'
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                style={{
                                    fontSize: "14px",
                                    color: "#747474",
                                    marginLeft: "52px",
                                }}
                            />
                        </Dropdown>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <Table
                // rowSelection={props.noAction ? null : rowSelection}
                columns={columns}
                dataSource={data}
                // pagination={{ showQuickJumper: true, pageSize: data.pageSize }}
                style={{ overflow: "none" }}
                loading={props.loading}
            />

            <Modal
                centered
                visible={DeleteModal}
                destroyOnClose
                maskClosable={false}
                onCancel={() => setDeleteModal(false)}
                footer={null}>
                <Row className='modal-row'>
                    <Row>
                        <Icon
                            type='delete'
                            style={{
                                color: "#181818",
                                fontSize: "24px",
                                marginRight: "16px",
                            }}
                        />
                        <Text
                            style={{
                                fontWeight: "bold",
                                color: "#181818",
                                fontSize: "24px",
                            }}>
                            Delete User
                        </Text>
                    </Row>
                    <Row style={{ marginTop: "24px" }}>
                        <Col span={24}>
                            <Text>{`Are you sure you want to delete this user`}</Text>
                        </Col>
                        <Col
                            style={{
                                marginTop: "60px",
                                textAlign: "right",
                            }}
                            span={18}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    boxShadow: "none",
                                    borderRadius: "20px",
                                    border: "none",
                                    backgroundColor: "#FFFFFF",
                                    color: "#181818",
                                }}
                                onClick={() => setDeleteModal(false)}>
                                Cancel
                            </Button>
                        </Col>
                        <Col
                            style={{
                                marginTop: "60px",
                                textAlign: "right",
                            }}
                            span={6}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    borderRadius: "2px",
                                    border: "none",
                                    backgroundColor: "#C91713",
                                    color: "#FFFFFF",
                                }}
                                onClick={() => {
                                    deleteInaamAdmin({
                                        requestData: {
                                            username: userdata?.username,
                                        },
                                        res200Callback: (res) => {
                                            setDeleteModal(false);
                                        },
                                    });
                                }}>
                                Delete User
                            </Button>
                        </Col>
                    </Row>
                </Row>
            </Modal>
            <AddUpdateMember loadTable={loadTable} addModal={addModal} setaddModal={setaddModal} userdata={{...userdata, password:""}} updateModal={true} />
            <Modal
                closable={false}
                centered
                visible={permissionModal}
                destroyOnClose
                maskClosable={false}
                onCancel={() => {
                    setPermissionModal(false);
                }}
                footer={null}
                width={900}>
                <Row className='modal-row'>
                    <Row>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Text
                                style={{
                                    // marginLeft: "16px",
                                    fontWeight: "700",
                                    color: "#181818",
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    lineHeight: "40px",
                                }}>
                                Manage Admin Permissions
                            </Text>
                            <Text
                                style={{
                                    // marginLeft: "16px",
                                    fontWeight: "normal",
                                    color: "#747474",
                                    fontSize: "16px",
                                    fontStyle: "normal",
                                    lineHeight: "24px",
                                }}>
                                Edit and Manage Admin Premissions
                            </Text>
                        </div>
                    </Row>

                    <Row
                        style={{
                            marginTop: "24px ",
                            background: "#E8E8E8",
                            height: "1px",
                        }}></Row>

                    <Row
                        style={{
                            height: "240px",
                            padding: "20px",
                            marginTop: "24px",
                            background: "#FFFFFF",
                            /* Grey / 5 */

                            boxSizing: "border-box",
                            borderRadius: "12px",
                        }}>
                        <Row>
                            <Row style={{ display: "flex" }}>
                                <div style={{ display: "flex", flex: "auto" }}>
                                    <div>
                                        <BusinessmanLogo style={{ margin: "10px", marginLeft: "0px" }} />
                                    </div>
                                    <Text
                                        style={{
                                            margin: "11px",
                                            marginLeft: "0px",
                                            fontWeight: "bold",
                                            color: "#181818",
                                            fontSize: "20px",
                                            fontStyle: "normal",
                                            lineHeight: "32px",
                                        }}>
                                        Admin Details
                                    </Text>
                                </div>
                                <div>
                                    <Button
                                        style={{
                                            height: "32px",
                                            width: "80px",
                                            borderRadius: "5px",
                                            margin: "7px",
                                            border: "none",
                                            backgroundColor: "#fec708",
                                            color: "#FFFFFF",
                                            float: "right",
                                        }}
                                        onClick={() => {
                                            setaddModal(true);
                                        }}>
                                        <Icon type='edit' />
                                        <Text
                                            style={{
                                                color: "#FFFFFF",
                                                fontWeight: "normal",
                                                fontSize: "14px",
                                                fontStyle: "normal",
                                                lineHeight: "22px",
                                            }}>
                                            Edit
                                        </Text>
                                    </Button>
                                </div>
                            </Row>
                            <Row>
                                <div
                                    style={{
                                        display: "flex",
                                        marginTop: "16px",
                                    }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            marginLeft: "10px",
                                            width: "50%",
                                        }}>
                                        <div>
                                            <AdminPremissionUserLogo style={{ marginRight: "10px" }} />
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <Text
                                                style={{
                                                    fontWeight: "normal",
                                                    color: "#747474",
                                                    fontSize: "14px",
                                                    fontStyle: "normal",
                                                    lineHeight: "22px",
                                                }}>
                                                Name
                                            </Text>
                                            <Text
                                                style={{
                                                    fontWeight: "700",
                                                    color: "#181818",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    lineHeight: "24px",
                                                }}>
                                                {userdata?.first_name && userdata?.last_name
                                                    ? `${userdata.first_name} ${userdata.last_name}`
                                                    : "-"}
                                            </Text>
                                        </div>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                        <AdminPremissionUsernameLogo />

                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                margin: "10px",
                                                marginTop: "0px",
                                            }}>
                                            <Text
                                                style={{
                                                    fontWeight: "normal",
                                                    color: "#747474",
                                                    fontSize: "14px",
                                                    fontStyle: "normal",
                                                    lineHeight: "22px",
                                                }}>
                                                Username
                                            </Text>
                                            <Text
                                                style={{
                                                    fontWeight: "700",
                                                    color: "#181818",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    lineHeight: "24px",
                                                }}>
                                                {userdata?.username || "-"}
                                            </Text>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                            <Row>
                                <div
                                    style={{
                                        display: "flex",
                                        marginTop: "16px",
                                    }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            marginLeft: "10px",
                                            width: "50%",
                                        }}>
                                        <div>
                                            <AdminPremissionEmailLogo style={{ marginRight: "10px" }} />
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <Text
                                                style={{
                                                    fontWeight: "normal",
                                                    color: "#747474",
                                                    fontSize: "14px",
                                                    fontStyle: "normal",
                                                    lineHeight: "22px",
                                                }}>
                                                Email Address
                                            </Text>
                                            <Text
                                                style={{
                                                    fontWeight: "700",
                                                    color: "#181818",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    lineHeight: "24px",
                                                }}>
                                                {userdata?.email || "-"}
                                            </Text>
                                        </div>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                        <AdminPremissionRoleLogo />

                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                margin: "10px",
                                                marginTop: "0px",
                                            }}>
                                            <Text
                                                style={{
                                                    fontWeight: "normal",
                                                    color: "#747474",
                                                    fontSize: "14px",
                                                    fontStyle: "normal",
                                                    lineHeight: "22px",
                                                }}>
                                                Role Assigned
                                            </Text>
                                            <Text
                                                style={{
                                                    fontWeight: "700",
                                                    color: "#181818",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    lineHeight: "24px",
                                                    textTransform: "capitalize",
                                                }}>
                                                {userdata?.admin_type?.toString().replace("_", " ") || "-"}
                                            </Text>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Row>
                    </Row>

                    <Row>
                        <PremissionTable
                            {...props}
                            permissionData={permissionData}
                            setPermissionData={setPermissionData}
                            userdata={userdata}
                        />
                    </Row>
                    <Row
                        type='flex'
                        justify='end'
                        align='middle'
                        style={{
                            marginTop: "32px",
                        }}>
                        <Button
                            size='large'
                            style={{
                                height: "40px",
                                boxShadow: "none",
                                borderRadius: "20px",
                                border: "none",
                                backgroundColor: "#FFFFFF",
                                color: "#181818",
                                marginRight: "12px",
                            }}
                            onClick={() => {
                                setPermissionModal(false);
                                setPermissionData([]);
                            }}>
                            Cancel
                        </Button>
                        <Button
                            size='large'
                            style={{
                                height: "40px",
                                borderRadius: "5px",
                                border: "none",
                                backgroundColor: "#fec708",
                                color: "#FFFFFF",
                            }}
                            onClick={() => {
                                permissionData.push("ANALYTICS");
                                console.log(" onclick permission :", permissionData);
                                setAdminPermissions({
                                    requestData: {
                                        username: userdata?.username,
                                        permissions: permissionData,
                                    },
                                    res200Callback: (res) => {
                                        loadTable();
                                        message.success("Permission Updated");
                                        setPermissionModal(false);
                                    },
                                });
                            }}>
                            Update Permission
                        </Button>
                    </Row>
                </Row>
            </Modal>
        </>
    );
};

const PremissionTable = (props) => {
    const { permissionData, setPermissionData, userdata } = props;

    useEffect(() => {
        console.log("permission : - ", permissionData);  
    }, [permissionData])
    

    const columns = [
        {
            title: "Module Name",
            dataIndex: "name",
            key: "name",
            render: (data) => {
                return (
                    <div style={{ width: "150px" }}>
                        <Text
                            style={{
                                fontWeight: "700",
                                fontSize: "16px",
                                lineHeight: "24px",
                                color: "#181818",
                                whiteSpace: "nowrap",
                            }}>
                            {data}
                        </Text>
                    </div>
                );
            },
        },
        {
            title: "View",
            dataIndex: "key",
            key: "key",
            render: (data) => {
                return (
                    <div>
                        <Switch
                            // defaultChecked={permissionData?.findIndex((item) => item === data) >= 0 || false}
                            checked = {permissionData?.findIndex((item) => item === data) >= 0 || false}
                            onClick={()=>{
                                if (permissionData?.findIndex((item) => item === data) >= 0 || false) {
                                    // let index = permissionData?.findIndex((item) => item === data);
                                    setPermissionData(permissionData?.filter(item=> item !== data ));
                                } else {
                                    setPermissionData([...permissionData, data]);
                                }
                                
                            }}
                            // onChange={(flag) => {
                            //     if (flag) {
                            //         setPermissionData([...permissionData, data]);
                            //     } else {
                            //         let index = permissionData?.findIndex((item) => item === data);
                            //         setPermissionData(permissionData?.splice(index, 1));
                            //     }
                            //     console.log("permission : - ", permissionData);
                            // }}
                        />
                    </div>
                );
            },
        },
    ];
    return (
        <Table
            // rowSelection={props.noAction ? null : rowSelection}
            columns={columns}
            dataSource={userdata.admin_type === "ADMIN" ? permissionListadmin : permissionList}
            style={{ overflow: "none" }}
            loading={props.loading}
            pagination={false}
        />
    );
};

const AddUpdateMember = (props) => {
    const { addModal, setaddModal, userdata, updateModal, loadTable } = props;
    const [successMessageModal, setsuccessMessageModal] = useState(false);
    const [userDetails, setuserDetails] = useState(userdata);

    useEffect(() => {
        setuserDetails(userdata);
        console.log("Member modal user data : ", JSON.stringify(userdata));
    }, [addModal]);

    return (
        <>
            <Modal
                centered
                visible={addModal}
                destroyOnClose
                maskClosable={false}
                onCancel={() => setaddModal(false)}
                footer={null}
                width={540}>
                <Row className='modal-row'>
                    <Row>
                        <div style={{ display: "flex" }}>
                            <div>
                                <UserLogo style={{ marginTop: "2px" }} />
                            </div>
                            <Text
                                style={{
                                    marginLeft: "16px",
                                    fontWeight: "700",
                                    color: "#181818",
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    lineHeight: "40px",
                                }}>
                                {updateModal ? "Edit Member" : "Add a new Member"}
                            </Text>
                        </div>
                    </Row>

                    <div
                        style={{
                            margin: "16px 0px",
                            background: "#E8E8E8",
                            height: "1px",
                        }}></div>

                    <Row style={{ marginTop: "24px" }}>
                        <div>
                            <div>
                                <Text
                                    style={{
                                        fontSize: "14px",
                                        color: "#181818",
                                        fontWeight: "bold",
                                        // fontWeight:"bold"
                                    }}>
                                    First Name
                                </Text>
                                <Input
                                    className='time-value-cohort-col-main-element'
                                    style={{ width: "100%", marginTop: "4px" }}
                                    placeholder='Enter First Name'
                                    value={userDetails?.first_name}
                                    onChange={(event) => {
                                        setuserDetails({
                                            ...userDetails,
                                            first_name: event.target.value,
                                        });
                                    }}
                                    name='first_name'
                                />
                            </div>
                            <div
                                style={{
                                    marginTop: "32px",
                                    //   display: "flex",
                                }}>
                                <Text
                                    style={{
                                        fontSize: "14px",
                                        color: "#181818",
                                        fontWeight: "bold",
                                        // fontWeight:"bold"
                                    }}>
                                    Last Name
                                </Text>
                                <Input
                                    className='time-value-cohort-col-main-element'
                                    style={{ width: "100%", marginTop: "4px" }}
                                    placeholder='Enter Username'
                                    // onChange={(e) => {
                                    //   addStoreManually.current.name = e.target.value;
                                    // }}
                                    value={userDetails?.last_name}
                                    onChange={(event) => {
                                        setuserDetails({
                                            ...userDetails,
                                            last_name: event.target.value,
                                        });
                                    }}
                                    name='last_name'
                                />
                            </div>

                            <div
                                style={{
                                    marginTop: "32px",
                                    //   display: "flex",
                                }}>
                                <Text
                                    style={{
                                        fontSize: "14px",
                                        color: "#181818",
                                        fontWeight: "bold",
                                        // fontWeight:"bold"
                                    }}>
                                    Username
                                </Text>
                                <Input
                                    className='time-value-cohort-col-main-element'
                                    style={{ width: "100%", marginTop: "4px" }}
                                    placeholder='Enter username'
                                    // onChange={(e) => {
                                    //   addStoreManually.current.name = e.target.value;
                                    // }}
                                    value={userDetails?.username}
                                    onChange={(event) => {
                                        setuserDetails({
                                            ...userDetails,
                                            username: event.target.value,
                                        });
                                    }}
                                    name='username'
                                />
                            </div>

                            <div
                                style={{
                                    marginTop: "32px",
                                    //   display: "flex",
                                }}>
                                <Text
                                    style={{
                                        fontSize: "14px",
                                        color: "#181818",
                                        fontWeight: "bold",
                                        // fontWeight:"bold"
                                    }}>
                                    Email
                                </Text>
                                <Input
                                    className='time-value-cohort-col-main-element'
                                    style={{ width: "100%", marginTop: "4px" }}
                                    placeholder='Enter Email address'
                                    // onChange={(e) => {
                                    //   addStoreManually.current.name = e.target.value;
                                    // }}
                                    value={userDetails?.email}
                                    onChange={(event) => {
                                        setuserDetails({
                                            ...userDetails,
                                            email: event.target.value,
                                        });
                                    }}
                                    name='email'
                                />
                            </div>

                            <div
                                style={{
                                    marginTop: "32px",
                                    width: "100%",
                                    display: Usertype === "super_admin" ? "block" : "none",
                                }}>
                                <Text
                                    style={{
                                        fontSize: "14px",
                                        color: "#181818",
                                        fontWeight: "bold",
                                        // fontWeight:"bold"
                                    }}>
                                    Select Role
                                </Text>
                                <Select
                                    // defaultValue={"ADMIN"}
                                    className='time-value-cohort-col-main-element'
                                    style={{ width: "100%", marginTop: "4px" }}
                                    placeholder='Select a role'
                                    name='role'
                                    value={userDetails?.admin_type}
                                    onChange={(value) => {
                                        setuserDetails({
                                            ...userDetails,
                                            admin_type: value,
                                        });

                                        console.log(userDetails?.admin_type)
                                    }}>
                                    {Roles.map((role) => {
                                        return <Option value={role}>{role}</Option>;
                                    })}
                                </Select>
                            </div>

                            <div
                                style={{
                                    marginTop: "32px",
                                    //   display: "flex",
                                }}>
                                <Text
                                    style={{
                                        fontSize: "14px",
                                        color: "#181818",
                                        fontWeight: "bold",
                                        // fontWeight:"bold"
                                    }}>
                                    Password
                                </Text>
                                <Input.Password
                                    className='add-member-password'
                                    style={{ width: "100%", marginTop: "4px" }}
                                    placeholder='Enter password'
                                    value={userDetails?.password}
                                    // visibilityToggle={true}
                                    onChange={(event) => {
                                        setuserDetails({
                                            ...userDetails,
                                            password: event.target.value,
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        <Row
                            style={{
                                marginTop: "28px ",
                                background: "#E8E8E8",
                                height: "1px",
                            }}></Row>
                        <Row
                            type='flex'
                            justify='end'
                            align='middle'
                            style={{
                                marginTop: "32px",
                            }}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    boxShadow: "none",
                                    borderRadius: "20px",
                                    border: "none",
                                    backgroundColor: "#FFFFFF",
                                    color: "#181818",
                                    marginRight: "12px",
                                }}
                                onClick={() => setaddModal(false)}>
                                Cancel
                            </Button>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    borderRadius: "5px",
                                    border: "none",
                                    backgroundColor: "#fec708",
                                    color: "#FFFFFF",
                                }}
                                onClick={() => {
                                    console.log("user Details :" + JSON.stringify(userDetails));
                                    if (updateModal) {
                                        updateInaamAdmin({
                                            requestData: userDetails,
                                            res200Callback: (res) => {
                                                console.log(`herecheck loadTableee`);
                                                loadTable();
                                                console.log(`after loadTableee`);
                                                setaddModal(false);
                                                setsuccessMessageModal(true);
                                                // message.success("User added successfully")
                                            },
                                        });
                                    } else {
                                        createInaamAdmin({
                                            requestData: userDetails,
                                            res200Callback: (res) => {
                                                setaddModal(false);
                                                setsuccessMessageModal(true);
                                                console.log(`herecheck loadTable`);
                                                // loadTable();
                                                // message.success("User added successfully")
                                            },
                                        });
                                    }
                                }}>
                                {updateModal ? "Update Member" : "Create Member"}
                            </Button>
                        </Row>
                    </Row>
                </Row>
            </Modal>
            <Modal
                closable={false}
                centered
                visible={successMessageModal}
                destroyOnClose
                maskClosable={false}
                onCancel={() => setaddModal(false)}
                footer={null}
                width={600}>
                <Row className='modal-row'>
                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}>
                        <div
                            style={{
                                width: "140px",
                                height: "140px",
                                background: "#E5F3FF",
                                textAlign: "center",
                                borderRadius: "100px",
                            }}>
                            <UserLogo
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    margin: "15px",
                                }}
                            />
                        </div>
                    </Row>
                    <Row
                        style={{
                            textAlign: "center",
                            marginTop: "24px",
                            marginBottom: "8px",
                        }}>
                        <Text
                            style={{
                                fontWeight: "700",
                                color: "#181818",
                                fontSize: "24px",
                                fontStyle: "normal",
                                lineHeight: "40px",
                            }}>
                            {updateModal ? "Admin User has been Updated" : "New Admin User has been created"}
                        </Text>
                    </Row>

                    <Row
                        style={{
                            textAlign: "center",
                        }}>
                        <Text
                            style={{
                                fontWeight: "500",
                                color: "#747474",
                                fontSize: "18px",

                                fontStyle: "normal",
                                lineHeight: "24px",
                            }}>
                            {updateModal
                                ? "Member details has been updated Successfully"
                                : "New Member Has been Added Successfully"}
                        </Text>
                    </Row>
                    <Row
                        type='flex'
                        justify='center'
                        align='middle'
                        style={{
                            marginTop: "32px",
                        }}>
                        <Button
                            size='large'
                            style={{
                                height: "40px",
                                borderRadius: "5px",
                                border: "none",
                                backgroundColor: "#fec708",
                                color: "#FFFFFF",
                            }}
                            onClick={() => {
                                // message.success("Button pressed");
                                setsuccessMessageModal(false);
                            }}>
                            Back to User Management
                        </Button>
                    </Row>
                </Row>
            </Modal>
        </>
    );
};

const UserManagment = (props) => {
    const [loading, setLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(true);
    const [addModal, setaddModal] = useState(false);

    const [searchKey, setSearchKey] = useState("");
    const [userList, setUserList] = useState(null);
    const [activityList, setActivityList] = useState(null);

    let userdata = {
        username:"",
        last_name:"",
        first_name:"",
        admin_type:"ADMIN",
        email:"",
        password:""
    }
    const [activeTab, setActiveTab] = useState("Members");

    const loadTable = () => {
        console.log(`usermgm load tab`);
        fetchInaamAdminList({
            res200Callback: (res) => {
                setUserList(res.data.reward_admin_list);
                setLoading(false);
                setTableLoading(false);
            },
        });
    };

    useEffect(() => {
        loadTable();
    }, [addModal]);

    return loading ? (
        <Row type='flex' align='middle' justify='center' style={{ marginTop: "200px" }}>
            <Loader />
        </Row>
    ) : (
        <Row
            style={{
                width: "100%",
                padding: "40px 25px 70px",
                margin: "60px auto 20px",
                backgroundColor: "#FAFAFA",
            }}
            gutter={[12, 48]}>
            <>
                <>
                    <Row type='flex' align='middle' justify='space-between'>
                        <Text
                            style={{
                                color: "#181818",
                                /*fontFamily: "Gotham",*/ fontStyle: "normal",
                                fontWeight: "bold",
                                fontSize: "24px",
                                lineHeight: "39px",
                            }}>
                            Admin Management
                        </Text>
                        <div style={{ display: "flex" }}>
                            <Button
                                onClick={() => setaddModal(true)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 16px",
                                    color: "#FFFFFF",
                                    fontSize: "14px",
                                    lineHeight: "24px",
                                    background: "#fec708",
                                    borderRadius: "5px",
                                    height: "100%",
                                    margin: "0 0 0 12px",
                                }}>
                                <Icon
                                    type='plus'
                                    style={{
                                        height: "16px",
                                    }}
                                />
                                Add Member
                            </Button>
                        </div>
                    </Row>

                    {/* <Menu
                        selectedKeys={activeTab}
                        onSelect={(e) => setActiveTab(e.key)}
                        mode='horizontal'
                        style={{ backgroundColor: "transparent" }}>
                        <Menu.Item key='Members'>
                            Members {`(${"3"})`}
                        </Menu.Item>
                        <Menu.Item key='Activities'>
                            Activities {`(${"0"})`}
                        </Menu.Item>
                    </Menu> */}

                    {activeTab === "Members" ? (
                        <UserTable
                            {...props}
                            loading={tableLoading}
                            data={userList}
                            // setUpdatePermission = {setUpdatePermission}
                            loadTable={loadTable}
                        />
                    ) : (
                        <ActivityManagment data={activityList} {...props} />
                    )}
                </>
                <AddUpdateMember  loadTable={loadTable} addModal={addModal} setaddModal={setaddModal} userdata={userdata} updateModal={false} />
            </>
        </Row>
    );
};

export default UserManagment;
